module.exports = __webpack_public_path__ + "static/media/github-star.068618a3.svg";